"use client";

import { AgentMarkLucideIcon } from "@v1/ui/agent-mark-icon";
import { cn } from "@v1/ui/utils";
import { UsersRound } from "lucide-react";
import type { ReactElement } from "react";

function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.charAt(0) ?? "";
  const last = parts.length > 1 ? (parts[parts.length - 1]?.charAt(0) ?? "") : "";
  return `${first}${last}`.toUpperCase() || "?";
}

/** Agent = triangle on a light tint (never a robot). */
export function MessengerAgentAvatar({ size = "md" }: { readonly size?: "sm" | "md" | "lg" }): ReactElement {
  return (
    <span
      aria-hidden
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full bg-action-500/[0.08] text-action-600",
        size === "sm" && "size-7",
        size === "md" && "size-8",
        size === "lg" && "size-10",
      )}
    >
      <AgentMarkLucideIcon className={cn(size === "lg" ? "h-[18px] w-[18px]" : "h-3.5 w-3.5")} />
    </span>
  );
}

export function MessengerPersonAvatar({ name }: { readonly name: string }): ReactElement {
  return (
    <span
      aria-hidden
      className="flex size-7 shrink-0 items-center justify-center rounded-full bg-action-500/[0.08] text-[10px] font-semibold leading-none text-primary/65"
    >
      {initialsOf(name)}
    </span>
  );
}

/** The team is in the conversation (a ticket): people icon, neutral tint. */
export function MessengerTeamAvatar({ size = "md" }: { readonly size?: "sm" | "md" }): ReactElement {
  return (
    <span
      aria-hidden
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full bg-muted text-primary/60",
        size === "sm" ? "size-7" : "size-8",
      )}
    >
      <UsersRound className={size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4"} strokeWidth={1.9} />
    </span>
  );
}
